import React from "react";
import { useDispatch } from "react-redux";
import { Flex, Button } from "ui-components";
import {
  getSignPassLinkUrl, buildJumioAuthHeaders, pathWithChannel, getMyInfoAuthorisedURL
} from "utils/helpers";
import FormattedMessage from "components/FormattedMessage";
import Logo from "assets/images/singpass_logo.png";
import LogoWhite from "assets/images/singpass_logo_white.png";
import { getButtonColorVariant, buttonThemes } from "ui-components/theme";
import styles from "./styles";
import Spinner from "components/Spinner";
import { setData, getSignPassLinkFulfilmentUrl } from "ducks/actions";
import { paths } from "utils/constants";

const MyInfoBox = ({
  title,
  btnLabel,
  fieldNameToClear,
  clearInfoLabel,
  setMyInfoIsUsed,
  clearMyInfoFormFields,
  clearMyInfoUrlParam,
  clearMyInfoDomain,
  myInfoIsUsed,
  appSettings,
  // signPass,
  jumioSessionToken
}) => {
  // console.log("AAA appSettings ", appSettings.enable_signpass_fulfillment_flow)
  const isSignpassFulfilment = appSettings?.enable_signpass_fulfillment_flow ?? false;
  // console.log("AAA1 appSettings ", isSignpassFulfilment)
  const link =
    !isSignpassFulfilment && getMyInfoAuthorisedURL(appSettings);
  // const link =
  //   getMyInfoAuthorisedURL(appSettings);
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = React.useState(false);

  const handleOnloginWithMyInfoClick = async () => {
    try {
      const headers = buildJumioAuthHeaders(jumioSessionToken);
      const params = {
        redirect_uri: pathWithChannel(
          window.location.origin + paths.PERSONAL_DETAILS
        ),
      }
      setIsLoading(true);
      await dispatch(getSignPassLinkFulfilmentUrl(
        headers,
        params,
        (response) => {
          const link =
            getSignPassLinkUrl(response)
          if (link) {
            window.location.assign(link);
          }
        }
      ));
    } catch (err) {
      console.error("API Error", err);
    }


    dispatch(setData({ key: "MyInfoEvent" }));
  };

  const onClearButtonClicked = () => {
    clearMyInfoUrlParam();
    clearMyInfoFormFields(fieldNameToClear);
    clearMyInfoDomain();
    setMyInfoIsUsed(false);
  };

  return (
    <Flex
      justifyContent={"center"}
      alignItems={"center"}
      flexDirection={"column"}
      pt={3}
      pb={2}
    >
      <Flex
        width="100%"
        alignItems={"center"}
        justifyContent={"center"}
        textAlign={"center"}
        sx={styles.title}
      >
        {title && (
          <div>
            <FormattedMessage html id={title} values={{ logo: Logo }} />
          </div>
        )}
      </Flex>

      {myInfoIsUsed ? (
        <Button
          variant="primary"
          sx={getButtonColorVariant(buttonThemes?.singpass)}
          onClick={onClearButtonClicked}

        >

          <FormattedMessage
            html
            id={clearInfoLabel || "my_info_clear_info_button"}
            values={{ logo: LogoWhite }}
          />
        </Button>
      ) : (
        <Button
          variant="primary"
          sx={getButtonColorVariant(buttonThemes?.singpass)}
          as={isSignpassFulfilment ? undefined : "a"}
          href={isSignpassFulfilment ? undefined : link}
          onClick={isSignpassFulfilment ? handleOnloginWithMyInfoClick : undefined}
        >
          {isLoading ? (
            <Spinner size={19} />
          ) : (
            <FormattedMessage
              html
              id={btnLabel || "my_info_retrieve_button"}
              values={{ logo: LogoWhite }}
            />
          )}
        </Button>
      )}
    </Flex>
  );
};

MyInfoBox.defaultProps = {
  fieldNameToClear: [],
  btnLabel: "my_info_retrieve_button",
  clearInfoLabel: "my_info_clear_info_button"
};

export default MyInfoBox;
